import MobileTitleBar from "components/MobileTitleBar"
import React, { Component, Fragment } from "react"
import { Container, Image, Button, Icon, Input } from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import shop from "shop/shop"
import Responsive from "react-responsive"
import Slider from "components/Slider/Slider"
import categoryStore                                  from "stores/categoryStore"
import CategoryShortcuts                                                                             from "plugin/CategoryShortcuts/CategoryShortcuts"
import {Card} from "semantic-ui-react"
import ImageWithFallback from "components/ImageWithFallback"
import {Link} from "react-router-dom"
import WordPressShopComponent from "../../../components/WordPressShopComponent/WordPressShopComponent";

export default class HomePageV2 extends Component {

    componentDidMount() {
        // Any initialization logic can go here

    }

    onNewsletterSubmit = (email) => {
        // Handle newsletter subscription logic here
        console.log("Newsletter subscription email:", email)
    }

    render() {
        let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
        const categories = categoryStore.categories
        const category = shop.categoriesById.get( categories ) || { children: categories }
        console.log( { category, categories } )
        console.log("shop", shop)
        return (
            <Fragment className="">
            <div className="backgroundImageBanner" >
            {/* Add the absolutely positioned div here */}
                <div className="container">
                <div className="MesseContainer">
                    <Responsive minWidth={1000}>
                        <div className="MesseBannerDiv ">
                            {/* Content of your div */}
                            <p style={{background: "rgba(255,255,255,0.85)", padding:"20px", borderRadius: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)"}}>
                                <WordPressShopComponent key={`homepage_banner`} slug={`homepage_banner`} />
                            </p>
                        </div>
                    </Responsive>
                </div>
                </div>
            </div>
            <Responsive minWidth={768}>
                            <div className="backgroundBenefitBanner" >
                <div className="container flex flex-row justify-between" >
                <div className="">
                <div style={{ textAlign: "center", paddingTop: "2vh"}}>
                  <table>
                    <tbody>
                        {/* */}
                      <tr>
                        <td  style={{ textAlign: "center" }} className="pa2 pt3 f3 fw6 black-60" >{translate("Einfach online bestellen und Ihre Ware rasch erhalten.")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div></div>
                    {/*               <div className="">
                <div style={{ textAlign: "center", paddingTop: "2vh"}}>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }} className="">
                            <Icon className="grey big clock "></Icon>
                        </td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7 black-60"> {translate("Support 24 / 7")}</td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center" }} className="pa2 pt3 f5 fw5 black-60 v-btm" >{translate("Einfach online bestellen und Ihre Ware rasch erhalten.")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div></div>
                                  <div className="">
                <div style={{ textAlign: "center", paddingTop: "2vh"}}>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }} className="">
                            <Icon className="grey big shield alternate"></Icon>
                        </td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7 black-60"> {translate("100% Authentic")}</td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center" }} className="pa2 pt3 f5 fw5 black-60" >{translate("Einfach online bestellen und Ihre Ware rasch erhalten.")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div></div> */}
                </div>
            </div>
            </Responsive>
            <Responsive maxWidth={767}>
                <div className="backgroundBenefitBannerMobile" >
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                <div style={{ textAlign: "center", paddingTop: "2vh"}}>
                                    <table>
                                    <tbody>
                                    {/*                                        <tr>
                                        <td style={{ textAlign: "center" }} className="">
                                            <Icon className="grey big truck"></Icon>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7 black-60"> {translate("Schnelle Lieferung")}</td>
                                        </tr> */}
                                        <tr>
                                        <td  style={{ textAlign: "center" }} className="pa2 pt3 f3 fw6 black-60" >{translate("Einfach online bestellen und Ihre Ware rasch erhalten.")} </td>
                                        </tr>
                                    </tbody>
                                    </table>
                                    </div>
                                </td>
                            </tr>
                            {/*                            <tr>
                                <td>
                                    <div style={{ textAlign: "center", paddingTop: "2vh"}}>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td style={{ textAlign: "center" }} className="">
                                                <Icon className="grey big clock "></Icon>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7 black-60"> {translate("Support 24 / 7")}</td>
                                        </tr>
                                        <tr>
                                            <td  style={{ textAlign: "center" }} className="pa2 pt3 f5 fw5 black-60 v-btm" >{translate("Einfach online bestellen und Ihre Ware rasch erhalten.")} </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>                                
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style={{ textAlign: "center", paddingTop: "2vh"}}>
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td style={{ textAlign: "center" }} className="">
                                                <Icon className="grey big shield alternate"></Icon>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7 black-60"> {translate("100% Authentic")}</td>
                                        </tr>
                                        <tr>
                                            <td  style={{ textAlign: "center" }} className="pa2 pt3 f5 fw5 black-60" >{translate("Einfach online bestellen und Ihre Ware rasch erhalten.")} </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
            </Responsive>

            <div className="container" style={{paddingTop: '4vh'}}>
                <div  className="tc">
                <WordPressShopComponent key={`homepage_category`} slug={`homepage_category`} />
                </div>
                <div>
                    <CategoryShortcuts title={category.title} category={category} itemsPerRow={3}/>
                </div>
            </div>
            <Responsive minWidth={768}>
                
            <div className="backgroundShowroomBanner" >
                <div className="container flex flex-row justify-between" >
                <div className="container flex flex-column justify-center tc">
                    <p className="primary f1 fw5 pb0" style={{color: "#79ab26", paddingBottom: "0px"}}>{translate("SHOWROOM")}</p>
                    <p className="pb2 black-70 f5">{translate("Vereinbaren Sie jetzt einen Termin mit uns!")}</p>      
                    <div><Link to="/customer_contact">
                        <Button style={{borderRadius:"35px", width: "250px", height: "50px"}} primary><p className="pt1">{translate("Termin vereinbaren")}</p></Button>    </Link>
                    </div>          
                </div>
                <div className="container flex flex-column justify-center">
                    <ImageWithFallback className="img-box" src={`${baseUrl}/wp/wp-content/uploads/showroom.jpg`} fallback={`${baseUrl}/wp/wp-content/uploads/2025/09/IMG_4575.jpg`} /></div>
                </div>
            </div>
            </Responsive>
            <Responsive maxWidth={767}>
                <div className="backgroundShowroomBannerMobile">
                <div className="container flex flex-column justify-center pa3 mt2 bt b--black-20">
                    <p className="primary f1 fw5 pa3" style={{color: "#79ab26", paddingBottom: "0px"}}>{translate("SHOWROOM")}</p>
                    <ImageWithFallback className="img-box" src={`${baseUrl}/wp/wp-content/uploads/showroom.jpg`} fallback={`${baseUrl}/wp/wp-content/uploads/2025/09/IMG_4575.jpg`} />
                </div>
             <div className="container flex flex-column justify-center tc">
                    
                    <p className="pb2 black-70 f5">{translate("Vereinbaren Sie jetzt einen Termin mit uns!")}</p>      
                    <div><Link to="/customer_contact">
                        <Button style={{borderRadius:"35px", width: "250px", height: "50px"}} primary><p className="pt1">{translate("Termin vereinbaren")}</p></Button>    </Link>
                    </div>          
                </div>
                </div>
            </Responsive>
            {/*            <div className="container" style={{paddingTop: '4vh'}}>
                <p style={{color: "#79ab26"}} className="f1 fw5 tc">{translate("UNTERNEHMEN")}</p>
                <p  className="f4 fw5 tc black-40">{translate("Hier steht ein wichtiger Text zum Unternehmen")}</p>
                <div className="container flex flex-row justify-between" style={{paddingTop: '4vh'}}>
                    <div className="">
                        <Card style={{border: "none"}} className={`CategoryCard`} as={Link}
						 to={`/home/`}>
                        <ImageWithFallback className="img-box"   fallback={"/image/placeholder.png"} />
                        
                        {<div className={" tc text-box-U"}>
                            <span className="category-title"> {translate("Kundenbetreuung")} </span>
                        </div>}
                        {<div className={" tc text-box-U-U fw5"}>
                            <span className="category-title"> {translate("Wichtiger Text für Kundenbetreuung")} </span>
                        </div>}
                        </Card>
                    </div>
                    <div className="">
                        <Card style={{border: "none"}} className={`CategoryCard`} as={Link}
						 to={`/home/`}>
                        <ImageWithFallback className="img-box"  fallback={"/image/placeholder.png"} />
                        
                        {<div className={" tc text-box-U"}>
                            <span className="category-title"> {translate("Warenhaus")} </span>
                        </div>}
                        {<div className={" tc text-box-U-U fw5"}>
                            <span className="category-title"> {translate("Wichtiger Text für Warenhaus")} </span>
                        </div>}
                        </Card>
                    </div>
                    <div className="">
                        <Card style={{border: "none"}} className={`CategoryCard`} as={Link}
						 to={`/home/`}>
                        <ImageWithFallback className="img-box"  fallback={"/image/placeholder.png"} />
                        
                        {<div className={" tc text-box-U"}>
                            <span className="category-title"> {translate("Produkte")} </span>
                        </div>}
                        {<div className={" tc text-box-U-U fw5"}>
                            <span className="category-title"> {translate("Wichtiger Text für Produkte")} </span>
                        </div>}
                        </Card>
                    </div>
                </div>
            </div> */}
            <Responsive minWidth={768}>
            <div className="backgroundNewsletterBanner" >
                
                
                <div className="tc">

                </div>
                <table>
                    <tbody>
                        <tr>
                            <td><p style={{color: ""}} className="f2 fw7 tc black-60">{translate("Sichern Sie sich die Vorteile des Newsletters")}</p></td>
                        </tr>
                        <tr>
                            <td className="pt2"><p  className="f4 fw5 tc black-40">{translate("Melden Sie sich an, um exklusive Inspirationen, Produktneuheiten und Sonderaktionen von uns zu erhalten.")}</p></td>
                        </tr>
                        <tr>
                            <td className="tc pt3"><Input placeholder={translate("E-Mail-Adresse")} />
                            <Button primary as={"a"} href={`mailto:innendienst@lucht.de?subject=Anmeldung zum Newsletter #${shop.session && shop.session.value ? shop.session.value.map_id : ''}`}>{translate("Anmelden")}</Button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </Responsive>

            <Responsive maxWidth={767}>
            <div className="backgroundNewsletterBannerMobile" >
                
                
                <div className="tc">

                </div>
                <table>
                    <tbody>
                        <tr>
                            <td><p style={{color: ""}} className="f2 fw7 tc black-60">{translate("Sichern Sie sich die Vorteile des Newsletters")}</p></td>
                        </tr>
                        <tr>
                            <td className="pt2"><p  className="f4 fw5 tc black-40">{translate("Melden Sie sich an, um exklusive Inspirationen, Produktneuheiten und Sonderaktionen von uns zu erhalten.")}</p></td>
                        </tr>
                        <tr>
                            <td className="tc pt3"><Input placeholder={translate("E-Mail-Adresse")} />
                            <Button primary as={"a"} href={`mailto:innendienst@lucht.de?subject=Anmeldung zum Newsletter #${shop.session && shop.session.value ? shop.session.value.map_id : ''}`}>{translate("Anmelden")}</Button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            </Responsive>
            </Fragment>
        )
    }
}




// WEBPACK FOOTER //
// ./src/theme/lucht-test/pages/HomePageV2.js